import floorplan2d from "./floorplan-2d.jpg";
import floorplan3d from "./floorplan-3d.jpg";

const photoModules = import.meta.glob('./img-*.jpg', { eager: true, import: 'default' }) as Record<string, string>;

export const stranciceImages: string[] = Object.entries(photoModules)
  .sort(([a], [b]) => {
    const na = parseInt(a.match(/img-(\d+)/)?.[1] || "0");
    const nb = parseInt(b.match(/img-(\d+)/)?.[1] || "0");
    return na - nb;
  })
  .map(([, src]) => src);

export const stranciceFloorPlans: { image: string; label: string }[] = [
  { image: floorplan2d, label: "Půdorys 2D" },
  { image: floorplan3d, label: "Půdorys 3D" },
];
